import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { format, parseISO } from "date-fns";

export default function UniversityChecksDataGrid({ data, onUpdate }) {
  if (!data || !data.universities) {
    return <div>No hay datos disponibles</div>;
  }

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "university", headerName: "Universidad", flex: 1, minWidth: 140 },
    {
      field: "document_count",
      headerName: "Número de Documentos",
      type: "number",
      width: 180,
    },
    {
      field: "latest_document_date",
      headerName: "Fecha del Documento Más Reciente",
      flex: 1,
      minWidth: 180,
      renderCell: (params) => {
        if (params.row.latest_document_date) {
          try {
            const date = parseISO(params.row.latest_document_date);
            return format(date, "dd/MM/yyyy");
          } catch (error) {
            console.error(
              "Error formatting date:",
              params.row.latest_document_date,
              error
            );
            return params.row.latest_document_date;
          }
        }
        return "N/A";
      },
    },
    {
      field: "oai_pmh_url",
      headerName: "URL OAI PMH",
      flex: 1,
      minWidth: 280,
      renderCell: (params) => {
        if (params.row.oai_pmh_url) {
          return (
            <a
              href={params.row.oai_pmh_url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "#1976d2" }}
            >
              {params.row.oai_pmh_url}
            </a>
          );
        }
        return "N/A";
      },
    },
    {
      field: "update",
      headerName: "Actualizar",
      width: 120,
      renderCell: (params) => (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onUpdate(params.row.university);
          }}
        >
          Actualizar
        </a>
      ),
    },
  ];

  const rows = data.universities.map((university, index) => ({
    id: index,
    university: university.university,
    document_count: university.document_count,
    latest_document_date: university.latest_document_date,
    oai_pmh_url: university.oai_pmh_url,
  }));

  return (
    <div
      className="checks-grid-container"
      style={{ height: "80vh", width: "100%" }}
    >
      <DataGrid
        density="compact"
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 100 },
          },
        }}
        pageSizeOptions={[25, 50, 100]}
        disableRowSelectionOnClick
        sx={{
          "& .MuiDataGrid-columnHeaders": { minHeight: 36, height: 36 },
          "& .MuiDataGrid-columnHeaderTitle": { fontSize: "0.9rem" },
          "& .MuiDataGrid-cell": { py: 0.25 },
        }}
      />
    </div>
  );
}
